<template>
  <el-dialog
    class="data-migration-set-server-config-dialog common-dialog"
    :close-on-click-modal="false"
    :visible.sync="dialogVisible"
    :title="title"
    top="35vh"
  >
    <el-form
      ref="serverDateForm"
      :rules="rules"
      :model="serverDateForm"
      :label-width="`${adaptationVars.formLabelWidth}px`"
      class="demo-dynamic"
    >
      <el-form-item class="server-long" prop="ip" label="服务器IP地址">
        <el-input v-model="serverDateForm.ip" :disabled="title == '修改服务器配置'"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="handleSubmit('serverDateForm')">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import adaptation from '@/mixins/adaptation'
export default {
  name: 'SetServerConfig',
  mixins: [adaptation],
  adaptationVarsDefine: {
    formLabelWidth: 100
  },
  data() {
    return {
      title: '设置IP地址',
      loadingBtn: false,
      dialogVisible: false,
      userid: '',
      isPing: false,
      serverDateForm: {
        ip: '' //服务ip
      },
      rules: {
        ip: [
          { required: true, message: '请输入服务地址名称', trigger: 'blur' },
          {
            pattern: /^(\d{1,3}\.){3}\d{1,3}:\d{1,5}$/,
            message: '请输入有效的服务地址',
            trigger: 'blur'
          }
        ]
      },
      adaptationVars: {
        formLabelWidth: 100
      }
    }
  },
  methods: {
    handleSubmit(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.handleCancel()
          this.$emit('serviceAddressChanged', this.serverDateForm.ip)
          this.$emit('update:list')
        } else {
          return false
        }
      })
    },
    handleCancel() {
      this.dialogVisible = false
    },
    handleOpen() {
      this.erverDateForm = {
        ip: '' //服务ip
      }
      this.dialogVisible = true
    }
  }
}
</script>

<style scoped lang="scss">
.data-migration-set-server-config-dialog.common-dialog {
  /deep/ .el-dialog {
    width: var(--common-dialog-medium-width);
  }

  .el-form {
    margin-right: var(--common-dialog-form-margin-right);

    .el-select {
      width: 100%;
    }

    /deep/ .el-form-item__content {
      display: flex;
    }
  }
}
</style>
